import { DateTime } from 'luxon'
export const utilsMixin = {
  methods: {
    formatDate(date, hasNoHour) {
      let fmtIn
      let fmtOut

      if (hasNoHour) {
        fmtIn = 'yyyy-MM-dd'
        fmtOut = 'dd/MM/yyyy'
      } else {
        fmtIn = 'yyyy-MM-dd HH:mm:ss'
        fmtOut = 'dd/MM/yyyy HH:mm:ss'
      }

      return DateTime.fromFormat(date, fmtIn).toFormat(fmtOut)
    },
    assertFormat(item) {
      const dateRegex = new RegExp(/^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/)
      const isDate = dateRegex.test(item.value)
      const hasNoHour = item.type !== 'DATE'
      return item.type === 'DATE' || isDate ? this.formatDate(item.value, hasNoHour) : item.value
    },
  },
}
